<template>
    <section class="page-section" v-if="infoData != {}">
                <p class="section-head">基本信息</p>
                <div class="info-table">
                    <p class="info-item">优惠券名称：{{ infoData.name }}</p>
                    <p class="info-item">领取时间：{{ infoData.getStartTime }}</p>
                </div>
                <div class="info-table">
                    <p class="info-item">优惠内容：{{ infoData.content }}</p>
                    <p class="info-item">用券时间：{{ infoData.useStartTime }}</p>
                </div>
                <div class="info-table">
                    <p class="info-item">发放总量：{{ infoData.putInLimit }}</p>
                    <p class="info-item">已领取：{{ infoData.getNum }}</p>
                </div>
                <div class="info-table">
                    <p class="info-item" style="width: auto;">使用说明：{{ infoData.instructions }}</p>
                </div>
                <!-- table -->
                <div class="table-region" v-loading="tableLoading">
                    <el-table size="small" :data="tableData">
                        <el-table-column label="领取账号">
                            <template slot-scope="scope">
                                <p v-if="scope.row.name"><router-link class="router-link-active" :to="{ path: '/user/user/detail', query: { id: scope.row.userId }}">{{ scope.row.name }}</router-link></p>
                                <p v-else>-</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="手机号">
                            <template slot-scope="scope">
                                <p v-if="scope.row.mobile">{{ scope.row.mobile }}</p>
                                <p v-else>-</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="来源">
                            <template slot-scope="scope">
                                <p v-if="scope.row.type == 1">主动注册</p>
                                <p v-if="scope.row.type == 2">微信H5</p>
                                <p v-if="scope.row.type == 3">和聊用户</p>
                                <p v-if="scope.row.type == 4">小程序用户</p>
                            </template>
                        </el-table-column>
                        <el-table-column label="领取时间">
                            <template slot-scope="scope">
                                <p>{{ scope.row.getDate }}</p>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="最终赠送对象">
                            <template slot-scope="scope">
                                <p v-if="scope.row.lastUserName"><router-link class="router-link-active" :to="{ path: '/user/user/detail', query: { id: scope.row.lastUserId }}">{{ scope.row.lastUserName }}</router-link></p>
                                <p v-else>-</p>
                            </template>
                        </el-table-column> -->
                        <!-- <el-table-column label="最终领取时间">
                            <template slot-scope="scope">
                                <p>{{ scope.row.lastGetDate }}</p>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="状态" align="right">
                            <template slot-scope="scope">
                                <p v-if="scope.row.status == 1">未使用</p>
                                <p v-if="scope.row.status == 2"><router-link class="router-link-active" :to="{ path: '/order/order/detail', query: { id: scope.row.orderId }}">已使用</router-link></p>
                                <p v-if="scope.row.status == 3">已过期</p>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- page -->
                    <div class="table-footer" v-if="true">
                        <div class="selection-operate"></div>
                        <div class="pagination-wrap">
                            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100]" :current-page="page.current" :page-size="page.size" layout="total, sizes, prev, pager, next, jumper" :total="page.total"></el-pagination>
                        </div>
                    </div>
                </div>
            </section>
</template>
<script>
    import { couponDetail } from "@/common/api";

    export default {
        name: "couponDetail",
        data() {
            return {
                id: this.$route.query.id || '',

                infoData: {},
                tableData: [], //表格数据,
                tableLoading: false,
                page: {
                    current: 1,
                    size: 20,
                    total: 0
                }
            };
        },
        methods: {
            /**
             * [handleSizeChange description] 分页每页条数变化
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleSizeChange(val) {
                this.page.current = 1;
                this.page.size = val;
                this.getList();
            },
            /**
             * [handleCurrentChange description] 选择分页第几页
             * @param  {[type]} val [description]
             * @return {[type]}     [description]
             */
            handleCurrentChange(val) {
                this.page.current = val;
                this.getList();
            },
            /**
             * [getList description] 获取表格数据
             * @return {[type]} [description]
             */
            getList: function () {
                this.tableLoading = true;

                let params = {
                    id: this.id,
                    pageNo: this.page.current,
                    pageSize: this.page.size
                }

                couponDetail(params).then(res => {
                    this.tableLoading = false;

                    let { code, data, msg } = res;

                    if (code == 0) {
                        this.infoData = data.couponDetailMessageVo;
                        this.tableData = data.couponDetailUserVos || [];
                        this.page.total = data.page.total;
                    } else {
                        this.$message.error(msg);
                    }
                }).catch(error => {
                    this.$message.error('服务器异常');
                });
            },
        },
        mounted() {
            this.getList();
        }
    };

</script>
<style lang="scss" scoped>
    @import "../../../common/styles/base/mixin-font";
    @import "../../../common/styles/base/mixin-common";

    .section-head {
        height: 36px;
        margin: 5px;
        padding-top: 8px;
        padding-left: 10px;
        font-size: 14px;
        background-color: #f5f5f5;
    }

    .info-table {
        margin-left: 13px;
        display: flex;
        flex-direction: row;

        .info-item {
            width: 400px;
            font-size: 12px;
            margin-top: 10px;
        }
    }

</style>
